<template>
  <div class="custom-select">
    <!-- 根据链接类型显示不同的输入控件 -->
    <!-- 内部链接 - 显示页面下拉列表：判断条件改为 linkType == 10 -->
    <div style="display: flex; align-items: flex-start">
      <el-select
        v-model="datas.linktype"
        placeholder="请选择跳转类型"
        size="mini"
        class="type-select"
        @change="handleLinkTypeChange($event, 1)"
        clearable
      >
        <el-option label="内部链接" value="10"></el-option>
        <el-option label="外部链接" value="11"></el-option>
      </el-select>
      <div
        v-if="datas.linktype == 10"
        style="margin-left: 5px; display: flex; align-items: flex-start"
      >
        <el-select
          class="type-select-inner"
          style="width: 100%"
          size="mini"
          placeholder="请选择内部页面"
          v-model="datas.http.internalLink"
          @change="handleInternalLinkChange(datas)"
        >
          <el-option
            v-for="page in pagesList"
            :key="page.pageId"
            :label="page.pageName"
            :value="page.pageId"
            :disabled="page.pageId !== datas.http.internalLink"
          >
          </el-option>
        </el-select>
        <el-button
          style="margin-left: 5px"
          v-if="!datas.pageId && isShow"
          type="primary"
          size="mini"
          @click.stop="
            handleInternalLinkChange({ http: { internalLink: NEW_PAGE_KEY } })
          "
          >新建页面</el-button
        >
      </div>
      <!-- 输入http 外部链接 -->
      <el-input
        style="margin-left: 5px; font-size: 12px"
        v-if="datas.linktype == 11"
        v-model="datas.http.externalLink"
        placeholder="请输入跳转链接"
        show-word-limit
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomSelectList",
  props: {
    // 是否显示新建页面按钮
    isShow: {
      type: Boolean,
      default: true,
    },
    datas: {
      type: Object,
      default: () => ({
        http: {
          internalLink: "", // 内部页面ID
          externalLink: "", // 外部跳转链接
        },
      }),
    },
    id: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedOption: "",
      NEW_PAGE_KEY: "_NEW_",
      currentItem: null,
      currentPageId: "",
      hasCreatedAlias: false,
      originalAlias: "",
    };
  },
  computed: {
    pagesList() {
      return this.$store.state.modules.templateData.pages;
    },
    // 当前组件已绑页面ID（直接挂载在datas根层级）
    hasAlias() {
      return this.datas?.pageId || "";
    },
  },
  created() {
    console.log("CustomSelectList下拉选择框组件挂载了", this.datas);
  },
  // 监听父组件传的type变化，同步更新子组件的localType (可选，做了更健壮)
  watch: {},
  methods: {
    // 核心方法：处理跳转类型选择变化，同步更新父组件的datas.linkType
    handleLinkTypeChange(val, type) {
      console.log("跳转类型", val, this.datas);
      // 跳转链接初始化
      this.datas.http = {
        internalLink: "", // 内部页面ID
        externalLink: "", // 外部跳转链接
      };
      this.$emit("update:type", val);
    },
    handleTypeChange(val) {
      console.log(
        "CustomSelect子组件的handleTypeChange方法",
        val,
        this.localType,
        this.datas
      );
    },
    resetData() {
      this.datas.http = {
        externalLink: "",
        internalLink: "",
      };
      delete this.datas.pageId;
      delete this.datas.pageName;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 新建页面
    async handleConfirm(val) {
      const newPage = {
        pageId:
          this.datas.id || this.datas.pageId || `${this.id}_${this.index}`,
        isBack: true,
        pageName: this.datas.moduleName || this.datas.text,
        path: this.datas.id || this.datas.pageId || `${this.id}_${this.index}`,
        pageSetup: this.$store.state.modules.templateData.global,
        components: [],
      };
      this.datas.pageId = newPage.pageId;
      console.log(
        "最终组装的页面pageIdJSON数据是---------",
        newPage,
        this.$store.state.modules.templateData,
        this.datas,
        this.id,
        this.index
      );
      const result = await this.$store.dispatch(
        "modules/addDynamicPage",
        newPage
      );
      if (result.success) {
        this.$message({
          message: "新建页面成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.datas.http.internalLink = this.datas.pageId;
        this.currentPageId = this.datas.pageId;
        console.log(
          "新建页面成功结果",
          this.formData,
          this.datas,
          newPage,
          result,
          this.$store.state.modules.templateData,
          this.pagesList,
          this.hasAlias,
          this.currentPageId
        );
      }
    },
    async handleInternalLinkChange(option) {
      var that = this;
      this.currentPageId = option.pageId || "";
      // 点击新建页面按钮逻辑
      if (option?.http?.internalLink === this.NEW_PAGE_KEY) {
        console.log("走新建页面逻辑", this.datas);
        this.handleConfirm();
      } else {
        // 下拉选择已有页面逻辑
        if (option?.http?.internalLink) {
          const currentItem = this.pagesList.find(
            (item) => item.pageId === option?.http?.internalLink
          );
          if (currentItem) {
            this.datas.pageId = currentItem.pageId;
            this.datas.pageName = currentItem.pageName;
          }
          console.log(
            "走更换事件逻辑了-----------------------",
            this.datas,
            currentItem
          );
        }
      }
      this.$emit("update:datas", this.datas);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep.el-select.type-select {
  .el-input {
    .el-input__inner {
      width: 120px;
      height: 28px;
      line-height: 28px;
    }
  }
}
::v-deep.el-input {
  .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
}
.custom-select {
}
</style>
